// Belt-and-braces draft persistence for the Request-a-CHANGE modal.
//
// The twin of bookingRequestDraft.js, and it exists for the same reason. The
// edit modal lets a client top up their wallet BY CARD from inside the
// "earn bonuses with the wallet" nudge (owner, 2026-07-19:  — the identical complaint applies
// one screen over, on the edit), and its own card-checkout handoff snapshots
// here too. A card payment hands the browser to the hosted paypage, which is a
// full navigation away: without a snapshot, the client pays successfully and
// lands back on a bookings list with their half-made change gone.
//
// LOCALSTORAGE, NOT SESSIONSTORAGE (item 4 kill/close, 2026-07-19). Same
// switch as the create draft: sessionStorage dies with the tab, so a crash or
// killed tab mid-payment destroyed the change the client was paying for.
// localStorage survives; staleness is the explicit TTL below (24h) plus the
// submit/discard clears. Same module API — callers don't change.
//
// Kept SEPARATE from the create draft on purpose. They are different intents —
// resuming one must never reopen the other — and they can legitimately coexist
// in the same tab. Different key, different resume param, no shared state.
//
// The stored form is the client's UNSAVED edits only; the booking itself is
// re-fetched on resume, so a booking that changed server-side in the meantime
// still loads its true current values and the draft only re-applies the fields
// the client had touched.

const KEY = 'hhc_booking_edit_draft';
const MAX_AGE_MS = 24 * 60 * 60 * 1000; // stale drafts die after a day

// One transitional read of the pre-switch sessionStorage key — a client
// mid-payment when this shipped keeps their draft. MIGRATED into localStorage
// (not merely consumed): callers read the draft several times before it is
// used, so a read must never destroy it.
function readLegacy() {
    try {
        const raw = sessionStorage.getItem(KEY);
        if (!raw) return null;
        localStorage.setItem(KEY, raw);
        sessionStorage.removeItem(KEY);
        return raw;
    } catch {
        return null;
    }
}

export function saveBookingEditDraft({ bookingId, form, tasks }) {
    try {
        localStorage.setItem(KEY, JSON.stringify({
            booking_id: bookingId, form, tasks, saved_at: Date.now(),
        }));
    } catch { /* storage full/blocked — the booking is unchanged either way */ }
}

export function loadBookingEditDraft() {
    try {
        const raw = localStorage.getItem(KEY) || readLegacy();
        if (!raw) return null;
        const draft = JSON.parse(raw);
        if (!draft || typeof draft !== 'object' || !draft.form) return null;
        if (draft.booking_id == null) return null;
        if (Date.now() - Number(draft.saved_at || 0) > MAX_AGE_MS) {
            clearBookingEditDraft();
            return null;
        }
        return draft;
    } catch {
        return null;
    }
}

export function clearBookingEditDraft() {
    try { localStorage.removeItem(KEY); } catch { /* nothing to clear */ }
    try { sessionStorage.removeItem(KEY); } catch { /* legacy key */ }
}

export function hasBookingEditDraft() {
    return loadBookingEditDraft() != null;
}
